import { Button, Grid } from "@mui/material";
import { ReactHookForm } from "../../../../components/hook-form/react-hook-form.component";
import { useReactHookForm } from "../../../../hooks/useReactHookForm";
import { HistoryForm } from "./history.form";
import { useSaveData } from "../../../../hooks/useSaveData";
import { equipmentApiKeyStore } from "../../../../api/masters/equipment-api-key-store";
import { historyFormSchema } from "./history-form.schema";
import { useAuthorize } from "../../../../hooks/use-authorize";
import { UserPermissionName } from "../../../../models/user-permission-name";

interface SaveHistoryComponent {
    equipmentID: any;
    equipmentHistory?: any;
    onClosed: () => void;
    onSaveHistory: () => void;
}
export const SaveHistoryComponent = ({ equipmentID, equipmentHistory, onClosed, onSaveHistory }: SaveHistoryComponent) => {
    const form = useReactHookForm({
        defaultValues: { ...(equipmentHistory && equipmentHistory) },
        yupSchema: historyFormSchema,
    });

    const { data, isLoading, mutateAsync } = useSaveData(
        equipmentHistory?.equipmentCalibrationHistoryID ?
            equipmentApiKeyStore.updateEquipmentCalibration() :
            equipmentApiKeyStore.createEquipmentCalibration(),
        () => equipmentApiKeyStore.getEquipmentCalibrations()
    );

    const handleSubmit = async (value: any) => {
        const data = {
            ...value,
            equipmentID: equipmentID,
            servicedOn: new Date(value.servicedOn)
        }
        const result = await mutateAsync({ data: data });
        onSaveHistory();
    }

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <ReactHookForm formName="SAVE_HISTORY_FORM" onSubmit={handleSubmit} formContextProps={form} isBusy={isLoading}>
            <Grid container>
                <HistoryForm />
                <Grid container justifyContent="space-between" spacing={1} style={{ paddingTop: 10 }}>
                    <Grid item>
                        <Button
                            style={{ width: 130 }}
                            variant="outlined"
                            disableElevation={true}
                            disabled={isLoading}
                            onClick={onClosed}
                        >
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            style={{ width: 130 }}
                            type="submit"
                            variant="contained"
                            disableElevation={true}
                            disabled={isLoading || isReadOnlyPermission}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </ReactHookForm>
    );
}